import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {MAX_RESULTS_PER_SECTION} from "../../../../constants/search"

import Deals from "./Deals"

const SearchBarResults = (props) => {
  const {results, onClick, searchTerm} = props
  const idNamespace = id("search-bar-results", props)
  return (
    <div id={idNamespace}>
      <Deals
        onClick={onClick}
        id="search"
        results={results[0]}
        maxResultsPerSection={MAX_RESULTS_PER_SECTION}
        searchTerm={searchTerm} />
    </div>
  )
}

SearchBarResults.propTypes = {
  results: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired
}

export default SearchBarResults
